import {
  Apps,
  initChildApps,
  resetAppDivTransforms,
  updateCanvasContext,
  resetProjections,
  switch3DView,
  updateAppLayout,
} from "../DicomManager";
import DicomLandmark from "./DicomLandmark.vue";

import {
  switchStitching,
  displayLastStitchingResult,
} from "@/components/appStart/stitching";
import { globalPlanes, empty } from "@/components/reports/ClipDialog.vue";
import { removeTeethNumbers } from "@/components/tooth/number/ToothNumberMode";
import {
  updateRaycaster,
  intersectTooth,
  setHighlightedToothColor,
} from "@/components/intersection";
import {
  focusTooth,
  unfocusTooth,
} from "@/components/tooth/focus/ToothFocusMode";
import { drawPoint, drawText } from "../../draw/draw";

//#region Fields

const toolName = "Analysis";
let landmarks = null;
let landmarks3d = [];

let AnalysisMode = {
  isActive: false,
  enterMode: function () {
    enterAnalysisMode();
  },
  leaveMode: function (saveActiveMode) {
    leaveAnalysisMode(saveActiveMode);
  },
  mouseUp: function (event) {
    return false;
  },
  mouseMove: function (event) {
    return true;
  },
  mouseClick: function (event) {},
  // toothEnter: function (tooth) { }
};

//#endregion

async function enterAnalysisMode() {
  console.log("enterAnalysisMode");
  let rootApp = Apps[0];
  rootApp.toolName = toolName;
  resetAppDivTransforms(rootApp);
  rootApp.resetZoom();
  updateCanvasContext(rootApp);
  $(`#${rootApp.settingsPanelId}`).collapse("hide");
  for (const xapp of Apps) {
    xapp.visible = false; //xapp == rootApp;
    if (xapp.frameMesh && viewer) {
      viewer.scene.remove(xapp.frameMesh);
    }
  }

  switchStitching("cbct");
  resetProjections(rootApp);

  const layerGroup = rootApp.getLayerGroupByDivId(rootApp.divId);
  const drawLayer = layerGroup.getActiveDrawLayer();
  drawLayer.deleteDraws(() => {});
  const viewLayer = layerGroup.getActiveViewLayer();
  viewLayer.noBackground = false;

  $(rootApp.annotationSpinnerId).css({ display: "block" });

  await loadAnalysisLandmarks();

  setTimeout(async function () {
    initChildApps(rootApp);

    $(".flex-item").css({ display: "none" });
    $("#stl_menu").css({ display: "none" });
    $(".annotation-off-item").css({ display: "none" });
    $(".annotation-on-item").css({ display: "block" });
    $(`#${rootApp.containerId}`).css({
      display: "block",
      height: "calc(100% + 35px)",
    });

    rootApp.onResize();
    rootApp.resetZoom();

    vueApp.leaveModes(false, true);
    vueApp.activeMode = AnalysisMode;
    AnalysisMode.isActive = true;
    viewer.renderer.clippingPlanes = empty;
    $("#bottomPanel").css("display", "none");
    $(".teeth-list-ctrl").css("display", "none");

    for (const app of rootApp.childApps) {
      setTimeout(() => {
        if (!app.dicomInitialized) {
          let image0 = null;
          const app0 = app.parentApp;
          const layerGroup = app0.getLayerGroupByDivId(app0.divId);
          if (layerGroup) {
            const activeLayer = layerGroup.getActiveViewLayer();
            const viewController = activeLayer.getViewController();
            image0 = viewController.getViewImage();
          }
          if (!image0) {
            image0 = app.parentApp.getImage(0);
          }
          if (image0) app.addNewImage(image0.clone());

          app.dicomInitialized = true;
        }
      }, 100);
    }

    switch3DView(Apps[0], true);
    $(rootApp.annotationSpinnerId).css({ display: "none" });
    vueApp.isDicomOpen = false;
  }, 50);
  // app.setTool(toolName);
}

async function leaveAnalysisMode() {
  resetProjections();

  $("#stl_menu").css({ display: "block" });
  $("#views3d_wrapper").css({ display: "block" });
  vueApp.isAnnotationMode = false;
  $(".teeth-list-ctrl").css("display", "block");
  switch3DView(Apps[0], false);

  $(".annotation-off-item").css({ display: "block" });
  $(".annotation-on-item").css({ display: "none" });
  $(`.annotation-settings-panel`).collapse("hide");
  $(`.dicom-settings-panel`).collapse("hide");
  // unfocusTooth();

  updateAppLayout();
}

async function loadAnalysisLandmarks() {
  console.log("loadAnalysisLandmarks");
  if (!landmarks) {
    try {
      let href = window.location.href;
      href = href.split(/[?#]/)[0];
      if (href.includes(".html"))
        href = href.substring(0, href.lastIndexOf("/"));
      href = trim(href, "/");

      let jsonUrl = `${href}/analysis/3d_analysys.json`;
      let response = await fetch(jsonUrl);
      let defLandmarks = await response.json();
      let ct_names = defLandmarks.map((x) => x.CT_name);

      jsonUrl = `${href}/analysis/predictions.json`;
      response = await fetch(jsonUrl);
      let predictions = await response.json();
      let prLandmarksLbs = Object.keys(predictions.landmarks);
      let prLandmarksEntries = Object.entries(predictions.landmarks);
      let prLandmarkObjs = [];
      for (const arr of prLandmarksEntries) {
        prLandmarkObjs.push({
          label: arr[0],
          position: arr[1].position,
          confidence: arr[1].confidence,
        });
      }
      console.log("prLandmarkObjs", prLandmarkObjs);

      jsonUrl = `${href}/analysis/predictions.mrk.json`;
      response = await fetch(jsonUrl);
      let predictions_mrk = await response.json();
      let prLandmarksMrk = predictions_mrk.markups[0].controlPoints;
      let prLandmarksMrkLbs = prLandmarksMrk.map((x) => x.label);

      const rootApp = Apps[0];
      const apanel = document.getElementById(rootApp.lpanelId);

      let mis1 = prLandmarksLbs.filter((x) => !prLandmarksMrkLbs.includes(x));
      let mis2 = prLandmarksMrkLbs.filter((x) => !prLandmarksLbs.includes(x));

      let mis3 = ct_names.filter((x) => !prLandmarksMrkLbs.includes(x));
      let mis4 = prLandmarksMrkLbs.filter((x) => !ct_names.includes(x));
      console.log("landmarks", mis1, mis2, mis3, mis4);

      // console.log("landmarks", ct_names, prLandmarks, prLandmarksMrkLbs);

      let numberFont = vueApp.defaultFont
        ? vueApp.defaultFont
        : await loadFont("fonts/helvetiker_regular.typeface.json");

      landmarks = [];
      viewer.controls.addEventListener("change", onCameraChangeForLandmarks);
      defLandmarks.forEach((item, index) => {
        let landmark = {
          name: item.Landmark,
          abbreviation: item.UI_name,
          definition: item.Definition,
          ctName: item.CT_name,
          isVisible: true,
          color: "#ff0000",
          hasFigures: true,
          isEdited: false,
        };
        landmarks.push(landmark);

        let prLandmark = prLandmarkObjs.find((x) => x.label === item.CT_name);
        let ctLandmark = prLandmarksMrk.find((x) => x.label === item.CT_name);
        if (ctLandmark) {
          landmark.prLandmark = prLandmark;
          landmark.ctLandmark = ctLandmark;

          let l3d = { landmark: landmark};
          landmarks3d.push(l3d);

          let ctPos = ctLandmark.position;
          landmark.dicomPos = new THREE.Vector3(ctPos[0], ctPos[1], ctPos[2]);

          let tempVector = landmark.dicomPos.clone();
          let matrix2 = new THREE.Matrix4();
          matrix2.makeRotationAxis(new THREE.Vector3(0, 1, 0), rotateY);
          tempVector.applyMatrix4(matrix2);
          let matrix1 = new THREE.Matrix4();
          matrix1.makeRotationAxis(new THREE.Vector3(1, 0, 0), rotateX);
          tempVector.applyMatrix4(matrix1);
          // tempVector.add(new THREE.Vector3(-defaultXOffset, -defaultYOffset, -defaultZOffset));

          landmark.pos3D = new THREE.Vector3(
            tempVector.x - defaultXOffset,
            tempVector.y - defaultYOffset,
            tempVector.z - defaultZOffset,
          );

          landmark.pos3D = new THREE.Vector3(
            tempVector.x - defaultXOffset,
            tempVector.y + defaultYOffset * 2 + 20,
            tempVector.z - defaultZOffset,
          );
          l3d.point = drawPoint(landmark.pos3D, 0xff0000, false, 0.8);

          landmark.textPoint = new THREE.Vector3(
            landmark.pos3D.x,
            landmark.pos3D.y + 3,
            landmark.pos3D.z + 3,
          );
          l3d.label = drawText(
            landmark.abbreviation,
            landmark.textPoint,
            numberFont,
            0xff0000,
          );
        }

        const landmarkInstance = new Vue({
          ...DicomLandmark,
          propsData: {
            landmark: landmark,
            app: rootApp,
            // dicomBox: _dicomBox,
          },
        });
        const vueContainer = document.createElement("div");
        apanel.appendChild(vueContainer);
        landmarkInstance.$mount(vueContainer);
      });
    } catch (error) {
      console.error("loadAnalysisLandmarks error", error);
    }
  }
}

function onCameraChangeForLandmarks(controls) {
  if (true) {
    // numbersVisible
    landmarks3d.forEach((item) => {
      let mesh = item.label;
      if (mesh) {
        mesh.up = viewer.camera.up;
        mesh.lookAt(viewer.camera.position);
      }
    });
  }
}

function focusLandmark() {
  console.log("addLandmark");
}

function addLandmark() {
  console.log("addLandmark");
}

function switchLandmarksVisible(lbVisible, lnVisible) {
  console.log("switchLandmarksVisible", lbVisible, lnVisible);

  landmarks3d.forEach((item) => {
    let pointMesh = item.point;
    if (pointMesh) {
      pointMesh.visible = lnVisible;
    }

    let lbMesh = item.label;
    if (lbMesh) {
      lbMesh.visible = lbVisible && lnVisible;
    }
  });
}

function switchLabelsVisible(lbVisible, lnVisible) {
  console.log("switchLabelsVisible", lbVisible, lnVisible);
  landmarks3d.forEach((item) => {
    let lbMesh = item.label;
    if (lbMesh) {
      lbMesh.visible = lbVisible && lnVisible;
    }
  });
}

export {
  enterAnalysisMode,
  leaveAnalysisMode,
  addLandmark,
  switchLandmarksVisible,
  switchLabelsVisible,
};
